import { gsap } from "gsap";
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Utils } from "../misc/Utils";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export class HomePageHandler extends PageHandler {
	constructor(id) {
		super(id);
		this.schedule = [];
        this.tableId = "wpdtSimpleTable-1"
	}

	
    storeWPDataTableData() {
        let i, numRows = document.getElementById(this.tableId).getAttribute('data-rows');

        for (i = 1; i < numRows; i++)
		{
			var cells = document.querySelectorAll(`.wpdt-cell[data-row-index="${i}"]`);

			var title = cells[0].textContent.trim();
			var date = cells[1].textContent.trim();
			var hour = cells[2].textContent.trim();
			var duration = cells[3].textContent.trim();
			var location = cells[4].textContent.trim();
			
			var mailSubject = `Κράτηση - Σεμινάριο "${title}"`;
			var mailBody = `Θα ήθελα να συμμετάσχω στο σεμινάριο "${title}" που ξεκινάει την ημερομηνία ${date}. Τα στοιχεία μου είναι τα εξής:\n\n<συμπληρώστε εδώ>`;

			this.schedule[i - 1] = {
				title: title,
				date: date,
				hour: hour,
				duration: duration,
				location: location,
				mailtoSubject: encodeURIComponent(mailSubject),
				mailtoBody: encodeURIComponent(mailBody)
			}
		}
    }

    buildSeminarScheduleDiv() {
        let $table = jQuery('main#homepage .schedule__table')
		let isEmpty = true;
		
        this.schedule.forEach((elem, index) => {
			if ((elem.title.length > 0) 
			|| (elem.date.length > 0) 
			|| (elem.hour.length > 0) 
			|| (elem.duration.length > 0) 
			|| (elem.location.length > 0))
			{
				isEmpty = false;
				var $container = jQuery(`
			  <div class="schedule__table-item">
				  <table>
					  <tr>
						  <th>Τίτλος</th>
						  <th>Ημερομηνία</th>
						  <th>Ώρα</th>
						  <th>Διάρκεια</th>
						  <th>Τοποθεσία</th>
					  </tr>
					  <tr>
						  <td>${elem.title}</td>
						  <td>${elem.date}</td>
						  <td>${elem.hour}</td>
						  <td>${elem.duration}</td>
						  <td>${elem.location}</td>
					  </tr>
				  </table>
				  <button class="primary-button"><a href="mailto:dr.ezafeiriou@gmail.com?subject=${elem.mailtoSubject}&body=${elem.mailtoBody}">Κράτηση</a></button>
			  </div>
			  `);
			  $table.append($container);
			}
				
        })

		if (isEmpty)
		{
			jQuery('main#homepage section.schedule').addClass('empty')
			jQuery('main#homepage section.schedule .schedule__table').html(`
				Προς το παρόν δεν υπάρχουν προγραμματισμένα σεμινάρια. 
				<a href="/contact#newsletter-subscribe">Κάνετε εγγραφή στο newsletter</a> για να λαμβάνετε ενημερώσεις!
			`)
		}
			
    }

	ajax() {

	}

	events() {
		/* On enter, About */
		ScrollTrigger.create({
			trigger: '.homepage .about__content',
			start: '50% bottom',
			onEnter: () => {
				gsap.fromTo('.homepage .about__content .about__left', 
					{autoAlpha: 0, x: -100},
					{autoAlpha: 1, x: 0, duration: 0.9}
				)
				gsap.fromTo('.homepage .about__content .about__right', 
					{autoAlpha: 0, x: 100},
					{autoAlpha: 1, x: 0, duration: 0.9}
				)
			},
			once: true
		})
		let mm = gsap.matchMedia();

		mm.add('(min-width: 769px)', () => {
			/* On enter, 1270 days */
			ScrollTrigger.create({
				trigger: '.homepage .groups__content--blue',
				start: 'bottom bottom',
				onEnter: () => {
					gsap.fromTo('.homepage .groups__content--blue', 
						{autoAlpha: 0, x: -100},
						{autoAlpha: 1, x: 0, duration: 0.9}
					)
				},
				once: true
			})

			/* On enter, Megala mora */
			ScrollTrigger.create({
				trigger: '.homepage .groups__content--pink',
				start: 'bottom bottom',
				onEnter: () => {
					gsap.fromTo('.homepage .groups__content--pink', 
						{autoAlpha: 0, x: 100},
						{autoAlpha: 1, x: 0, duration: 0.9}
					)
				},
				once: true
			})
		});

		mm.add('(max-width: 768px)', () => {
			/* On enter, 1270 days */
			ScrollTrigger.create({
				trigger: '.homepage .groups__content--blue',
				start: '50% bottom',
				onEnter: () => {
					gsap.fromTo('.homepage .groups__content--blue', 
						{autoAlpha: 0, x: -100},
						{autoAlpha: 1, x: 0, duration: 0.9}
					)
				},
				once: true
			})

			/* On enter, Megala mora */
			ScrollTrigger.create({
				trigger: '.homepage .groups__content--pink',
				start: '50% bottom',
				onEnter: () => {
					gsap.fromTo('.homepage .groups__content--pink', 
						{autoAlpha: 0, x: 100},
						{autoAlpha: 1, x: 0, duration: 0.9}
					)
				},
				once: true
			})

		});
		
		/* On enter, Counseling */
		ScrollTrigger.create({
			trigger: '.homepage .counseling',
			start: '60% bottom',
			onEnter: () => {
				gsap.fromTo('.homepage .counseling__content', 
					{autoAlpha: 0, y: 100},
					{autoAlpha: 1, y: 0, duration: 0.9}
				)
			},
			once: true
		})

		/* On enter, Supervision */
		ScrollTrigger.create({
			trigger: '.homepage .supervision',
			start: '60% bottom',
			onEnter: () => {
				gsap.fromTo('.homepage .supervision__content', 
					{autoAlpha: 0},
					{autoAlpha: 1, duration: 0.2}
				)
				gsap.fromTo('.homepage .supervision__background img', 
					{autoAlpha: 0, scale: 1.2},
					{autoAlpha: 1, scale: 1, duration: 0.9}
				)

				gsap.fromTo('.homepage .supervision__content-inside', 
					{autoAlpha: 0, x: -50},
					{autoAlpha: 1, x: 0, duration: 0.9}
				)
			},
			once: true
		})

		/* On enter, IG posts */
		gsap.set(".instagram__post", {autoAlpha: 0, y: 100});
		ScrollTrigger.batch(".instagram__post", {
			onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
		});
	}

	transitions() {
		imagesLoaded( document.querySelector('.homepage .hero__left'), function (instance) {
			Utils.fadeInFrom('.homepage .hero__left', 0.7)
		})
		gsap.fromTo('.homepage .hero__right', {autoAlpha: 0, x: 50}, {autoAlpha: 1, x: 0, duration: 0.7})
	}

	init() {
		this.storeWPDataTableData();
		this.buildSeminarScheduleDiv();
		this.events();
	}

	destroy() {

	}
}
